import { atom } from 'jotai';
import { Global_Product_Family_Enum, Product_Sub_Family_Name_Enum } from '@kheops/graphql';

export interface ProductFamilySettings {
  global_setting?: Global_Product_Family_Enum;
  product_sub_families?: Set<Product_Sub_Family_Name_Enum>;
}

export const productFamiliesSettingsAtom = atom<ProductFamilySettings>({});
